/* ──────────────────────────────────────────────────────────
   bankLensApi.js — API service layer for BankLens dashboard
   Fetches data from the BankLens Azure Functions backend
   ────────────────────────────────────────────────────────── */
import apiClient from '../../../services/apiClient';

export async function fetchOverview() {
    const res = await apiClient.get('/banklens/overview');
    return res.data?.data ?? res.data;
}

export async function fetchBankDetail(ticker) {
    const res = await apiClient.get(`/banklens/banks/${encodeURIComponent(ticker)}`);
    return res.data?.data ?? res.data;
}

export async function fetchCompare(tickers) {
    const params = tickers?.length ? { tickers: tickers.join(',') } : {};
    const res = await apiClient.get('/banklens/compare', { params });
    return res.data?.data ?? res.data;
}

export async function refreshLiveQuotes(tickers) {
    const params = tickers?.length ? { tickers: tickers.join(',') } : {};
    const res = await apiClient.post('/banklens/refresh-live', null, { params });
    return res.data?.data ?? res.data;
}
